import { RefObject, ReactNode } from "react"
import { BRAND } from "../../constants"
import { CarouselHeightsSizes, SLIDE_SIZES } from "../../models/types/Carousel.type"

type ScrollAreaProps = {
    handleScroll: () => void
    handleNavigate: (direction: string) => void
    size: CarouselHeightsSizes
    centered: boolean
    scrollAreaRef: RefObject<HTMLUListElement | null>
    children: ReactNode[]
    activeSlide: number
    isLarge: boolean
}

function ScrollArea({ handleScroll, handleNavigate, size, centered, scrollAreaRef, children, activeSlide, isLarge }: ScrollAreaProps) {
  const count = children.length
  return (
    <div className='inner-carousel'>
      <ul className='scroll-container' onScroll={handleScroll} ref={scrollAreaRef}>
        {children && children.map((child, index) => (
          <li
            onFocus={() => {
              if (activeSlide !== index && isLarge) {
                activeSlide > index ? handleNavigate('left') : handleNavigate('right')
              }
            }}
            className={`slide ${isLarge ? (activeSlide === index ? 'large active' : 'large') : ''}`}
            key={`slide-${index}-key`}
            id={`slide-${index}`}>
            {child}
          </li>
        ))}
      </ul>
      <style jsx>
        {`
          .inner-carousel {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
            direction: ltr;
          }

          .scroll-container {
            scroll-behavior: smooth;
            padding: 0 0 20px;
            overflow-x: auto;
            overflow-y: hidden;
            touch-action: pan-x pan-y pinch-zoom;
            flex-direction: row;
            justify-content: ${centered && !isLarge ? 'center' : 'normal'};
            scroll-snap-type: x mandatory;
            width: 100%;
            height: 100%;
            display: flex;
            outline: none;
            position: relative;
            flex-grow: 1;
            flex-wrap: nowrap;
            box-sizing: content-box;
            list-style: none;
            margin: 0;
          }

          .slide {
            flex: ${`0 0 calc(${SLIDE_SIZES[size].sm} - 16px)`};
            scroll-snap-align: ${isLarge ? 'center' : 'start'};
            scroll-snap-stop: always;
            scroll-margin: 8px;
            display: flex;
            overflow: hidden;
            position: relative;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            margin: 0 8px;
            height: fit-content;
            transition: filter 0.5s;
          }

          .large {
            filter: brightness(50%);
          }

          .active {
            filter: brightness(100%);
          }

          @media screen and (min-width: ${BRAND.media.small}px) {
            .slide {
              flex: ${`0 0 calc(${SLIDE_SIZES[size].md} - ${isLarge ? '32px' : '16px'})`};
              min-width: ${count < 2 ? '410px' : 'initial'};
            }

            .large.slide:first-child {
              margin-left: calc(10% + 16px);
            }

            .large.slide:last-child {
              margin-right: calc(10% + 16px);
            }
          }

          @media screen and (min-width: ${BRAND.media.tablet}px) {
            .slide {
              flex: ${`0 0 calc(${SLIDE_SIZES[size].lg} - ${isLarge ? '32px' : '16px'})`};
              min-width: ${size !== 'small' && count < 3 ? '420px' : 'initial'};
            }
          }
        `}
      </style>
    </div>
  )
}

export default ScrollArea